/**
 * Formats a string so that it can be safely used in an
 * ICS LOCATION or SUMMARY field according to the RFC 5545 standard.
 */
export default function escapeICS(str: string): string {
    if (!str) {
        return ''
    }

    return (
        str
            // 1. Replace backslashes first (otherwise you escape the escapes)
            .replace(/\\/g, '\\\\')
            // 2. Escape commas and semicolons
            .replace(/,/g, '\\,')
            // 3. Escape semicolons
            .replace(/;/g, '\\;')
            // 4. Replace new lines by the literal text \n
            .replace(/\n/g, '\\n')
            // 5. Replace carriage returns by an empty string
            .replace(/\r/g, '')
    )
}
